type AuthUiContext = 'login' | 'signup' | 'reset';

/** Mensajes en inglés de GoTrue → español (Rioplatense) para la UI de login/registro. */
export function userFacingSupabaseAuthMessage(
  raw: string,
  ctx: AuthUiContext,
  err?: { code?: string; status?: number; message?: string }
): string {
  const m = (raw || '').trim();
  const lower = m.toLowerCase();
  const code = String(err?.code ?? '').toLowerCase();

  // Rate limit: UX only — no Sentry (VUELTO-NEGOCIO-1V / 1X)
  if (err?.status === 429 || lower.includes('too many') || lower.includes('rate limit')) {
    return 'Demasiados intentos. Probá más tarde.';
  }

  if (ctx === 'login') {
    if (
      code === 'invalid_credentials' ||
      lower.includes('invalid login credentials') ||
      lower.includes('invalid credentials')
    ) {
      return 'Correo o contraseña incorrectos. Si olvidaste la contraseña, usá «¿Olvidaste tu contraseña?» más abajo.';
    }
    if (code === 'email_not_confirmed' || lower.includes('email not confirmed')) {
      return 'Falta confirmar el correo. Revisá tu bandeja (y spam) y abrí el enlace que te enviamos.';
    }
  }

  if (ctx === 'signup') {
    if (
      code === 'user_already_registered' ||
      code === 'signup_disabled' ||
      lower.includes('user already registered') ||
      lower.includes('already registered')
    ) {
      return 'Ya existe una cuenta con ese correo. Probá iniciar sesión o recuperá la contraseña.';
    }
    if (lower.includes('password') && (lower.includes('at least') || lower.includes('least 6'))) {
      return 'La contraseña no cumple los requisitos. Usá al menos 8 caracteres.';
    }
    if (code === 'validation_failed' || lower.includes('invalid format') || lower.includes('invalid email')) {
      return 'El correo no es válido. Revisá que esté bien escrito y sin caracteres raros.';
    }
  }

  if (ctx === 'reset') {
    if (lower.includes('invalid email') || code === 'validation_failed') {
      return 'Correo inválido. Verificá que esté bien escrito.';
    }
  }

  if (/[áéíóúñ¿¡]/i.test(m)) return m;

  if (m) {
    if (ctx === 'login') return 'No pudimos iniciar sesión. Probá de nuevo o recuperá la contraseña.';
    if (ctx === 'signup') return 'No pudimos crear la cuenta. Probá de nuevo.';
    return 'No pudimos enviar el correo. Probá de nuevo.';
  }

  if (ctx === 'login') return 'No pudimos iniciar sesión.';
  if (ctx === 'signup') return 'No pudimos registrar la cuenta.';
  return 'No pudimos enviar el correo.';
}
